// Ticket photos: what may be uploaded and how a stored row is described.

export const PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const PHOTO_ACCEPT = PHOTO_TYPES.join(',');
// The server's defaults when the settings have not loaded.
export const DEFAULT_MAX_IMAGES = 10;
export const DEFAULT_MAX_IMAGE_MB = 5;

// Checked in the browser before anything is sent; the server checks again and
// reads the real type from the bytes. Returns 'TYPE', 'SIZE' or ''.
export function photoProblem(file, maxMb = DEFAULT_MAX_IMAGE_MB) {
  if (!PHOTO_TYPES.includes(file.type)) return 'TYPE';
  if (file.size > maxMb * 1024 * 1024) return 'SIZE';
  return '';
}

// Photos that count toward the limit: stored and still-being-copied ones.
export const photoCount = media =>
  (media || []).filter(
    item => item.status === 'stored' || item.status === 'pending'
  ).length;

// How many more may be added.
export const photoRoom = (media, maxImages = DEFAULT_MAX_IMAGES) =>
  Math.max(0, maxImages - photoCount(media));

// A chat photo that was not copied: which words explain it. `null` for a
// photo that is stored or still waiting.
const NOT_COPIED = {
  not_an_image: 'NOT_AN_IMAGE',
  too_large: 'TOO_LARGE',
  too_many_photos: 'LIMIT',
  attachment_not_found: 'NOT_FOUND',
  attachment_unreachable: 'OPEN_IN_CHAT',
};

export function photoNote(item) {
  if (item.status === 'pending') return 'COPYING';
  if (item.status === 'stored') return null;
  return NOT_COPIED[item.error] || 'COULD_NOT_COPY';
}
